<template>
    <v-chip
        class="person-label immutable-text"
        small
        label
        dark
        :color="chipColor"
        :style="{'opacity': chipOpacity}"
    >
        <div 
            class="if-more-tooltip-chip"
            v-tooltip.top-center="name"
        >
            <v-icon :color="iconColor">{{ icon }}</v-icon>
            <div :style="{'color': textColor}">{{name}}</div>
        </div>
    </v-chip>
</template>

<script>
export default {
    name: "TagChip",
    props: {
        name: {
            type: String,
            default: ""
        },
        icon: {
            type: String,
            default: "fas fa-tag"
        },
        iconColor: {
            type: String,
            default: "#494949"
        },
        chipColor: {
            type: String,
            default: "#e0e0e0"
        },
        chipOpacity: {
            type: String,
            default: "1"
        },
        textColor: {
            type: String,
            default: "#494949"
        }

    }
}
</script>